import * as Types from '../../../../../types.generated';

import { gql } from '@apollo/client';
import { TranslationSetFragmentDoc, CoverImageFragmentDoc, AvatarProfileImageFragmentDoc } from '../../../../../fragments.generated';
import { TagFragmentDoc } from '../../../../../lib/contexts/TagContext/TagContext.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JumpToPeopleQueryVariables = Types.Exact<{
  input: Types.GetPeopleInput;
}>;


export type JumpToPeopleQuery = { __typename?: 'Query', Employees: { __typename?: 'Employees', objects: Array<{ __typename?: 'Employee', id: number, name: string, email?: string | null, phoneNumber?: string | null, userType: Types.UserType, deactivatedAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } };

export type JumpToLibraryItemsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type JumpToLibraryItemsQuery = { __typename?: 'Query', LibraryItems: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, searchHeadline?: string | null, course?: { __typename?: 'Course', id: number } | null, module?: { __typename?: 'Module', id: number } | null, skill?: { __typename?: 'Skill', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, media?: { __typename?: 'Media', id: number, unoptimizedUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, original: string } | null } | null } | null } | null, scormCourse?: { __typename?: 'SCORMCourse', id: string } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, setupStep: Types.PremiumContentSetupStep, catalogConfig: { __typename?: 'PremiumContentConfig', id: number, catalogModule?: { __typename?: 'CatalogModule', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } } | null } } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null }> } };

export type JumpToOrgPremiumContentConfigFragment = { __typename?: 'OrgPremiumContentConfig', id: number, setupStep: Types.PremiumContentSetupStep, catalogConfig: { __typename?: 'PremiumContentConfig', id: number, catalogModule?: { __typename?: 'CatalogModule', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } } | null } };

export type JumpToLocationGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JumpToLocationGroupsQuery = { __typename?: 'Query', LocationGroups: { __typename?: 'LocationGroups', objects: Array<{ __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType, locationMemberships: Array<{ __typename?: 'LocationGroupMembership', id: string }> }> } };

export type JumpToLocationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JumpToLocationsQuery = { __typename?: 'Query', Locations: { __typename?: 'Locations', objects: Array<{ __typename?: 'Location', id: number, name: string }> } };

export type JumpToRoleGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JumpToRoleGroupsQuery = { __typename?: 'Query', RoleGroups: { __typename?: 'RoleGroups', objects: Array<{ __typename?: 'RoleGroup', id: string, name: string, roleMemberships: Array<{ __typename?: 'RoleGroupMembership', id: string }> }> } };

export type JumpToRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JumpToRolesQuery = { __typename?: 'Query', Roles: { __typename?: 'Roles', objects: Array<{ __typename?: 'Role', id: number, name: string }> } };

export type JumpToTagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JumpToTagsQuery = { __typename?: 'Query', Tags: Array<{ __typename?: 'Tag', id: string, availableInApp: boolean, pinned?: boolean | null, nameTranslations: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } }> };

export type JumpToEmployeeFragment = { __typename?: 'Employee', id: number, name: string, email?: string | null, phoneNumber?: string | null, userType: Types.UserType, deactivatedAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null };

export type JumpToCourseFragment = { __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } };

export type JumpToModuleFragment = { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } };

export type JumpToTrainingResourceFragment = { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, media?: { __typename?: 'Media', id: number, unoptimizedUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, original: string } | null } | null } | null };

export type JumpToSkillFragment = { __typename?: 'Skill', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } };

export type JumpToLocationFragment = { __typename?: 'Location', id: number, name: string };

export type JumpToRoleFragment = { __typename?: 'Role', id: number, name: string };

export type JumpToLocationGroupFragment = { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType, locationMemberships: Array<{ __typename?: 'LocationGroupMembership', id: string }> };

export type JumpToRoleGroupFragment = { __typename?: 'RoleGroup', id: string, name: string, roleMemberships: Array<{ __typename?: 'RoleGroupMembership', id: string }> };

export const JumpToOrgPremiumContentConfigFragmentDoc = gql`
    fragment JumpToOrgPremiumContentConfig on OrgPremiumContentConfig {
  id
  catalogConfig {
    id
    catalogModule {
      id
      module {
        id
        libraryItem {
          id
          coverImage {
            ...CoverImage
          }
          name {
            ...TranslationSet
          }
          searchHeadline
        }
      }
    }
  }
  setupStep
}
    ${CoverImageFragmentDoc}
${TranslationSetFragmentDoc}`;
export const JumpToEmployeeFragmentDoc = gql`
    fragment JumpToEmployee on Employee {
  id
  name
  email
  phoneNumber
  userType
  deactivatedAt
  locations {
    id
    name
  }
  profileImage {
    ...AvatarProfileImage
  }
}
    ${AvatarProfileImageFragmentDoc}`;
export const JumpToCourseFragmentDoc = gql`
    fragment JumpToCourse on Course {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    searchHeadline
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const JumpToModuleFragmentDoc = gql`
    fragment JumpToModule on Module {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    searchHeadline
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const JumpToTrainingResourceFragmentDoc = gql`
    fragment JumpToTrainingResource on TrainingResource {
  id
  publishedVersion {
    id
    media {
      id
      mediaUrls {
        ...TranslationSet
      }
      imageUrls {
        id
        thumb
        original
      }
      unoptimizedUrl
    }
  }
}
    ${TranslationSetFragmentDoc}`;
export const JumpToSkillFragmentDoc = gql`
    fragment JumpToSkill on Skill {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    searchHeadline
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const JumpToLocationFragmentDoc = gql`
    fragment JumpToLocation on Location {
  id
  name
}
    `;
export const JumpToRoleFragmentDoc = gql`
    fragment JumpToRole on Role {
  id
  name
}
    `;
export const JumpToLocationGroupFragmentDoc = gql`
    fragment JumpToLocationGroup on LocationGroup {
  id
  name
  type
  locationMemberships {
    id
  }
}
    `;
export const JumpToRoleGroupFragmentDoc = gql`
    fragment JumpToRoleGroup on RoleGroup {
  id
  name
  roleMemberships {
    id
  }
}
    `;
export const JumpToPeopleDocument = gql`
    query JumpToPeople($input: GetPeopleInput!) {
  Employees: People(input: $input, pagination: {limit: 20}) {
    objects {
      ...JumpToEmployee
    }
  }
}
    ${JumpToEmployeeFragmentDoc}`;

/**
 * __useJumpToPeopleQuery__
 *
 * To run a query within a React component, call `useJumpToPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToPeopleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJumpToPeopleQuery(baseOptions: Apollo.QueryHookOptions<JumpToPeopleQuery, JumpToPeopleQueryVariables> & ({ variables: JumpToPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToPeopleQuery, JumpToPeopleQueryVariables>(JumpToPeopleDocument, options);
      }
export function useJumpToPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToPeopleQuery, JumpToPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToPeopleQuery, JumpToPeopleQueryVariables>(JumpToPeopleDocument, options);
        }
export type JumpToPeopleQueryHookResult = ReturnType<typeof useJumpToPeopleQuery>;
export type JumpToPeopleLazyQueryHookResult = ReturnType<typeof useJumpToPeopleLazyQuery>;
export type JumpToPeopleQueryResult = Apollo.QueryResult<JumpToPeopleQuery, JumpToPeopleQueryVariables>;
export const JumpToLibraryItemsDocument = gql`
    query JumpToLibraryItems($input: AdminLibraryInput!, $pagination: PaginationInput) {
  LibraryItems: AdminLibrary(input: $input, pagination: $pagination) {
    objects {
      id
      type
      course {
        id
      }
      module {
        id
      }
      skill {
        id
      }
      trainingResource {
        id
      }
      scormCourse {
        id
      }
      name {
        ...TranslationSet
      }
      coverImage {
        ...CoverImage
      }
      trainingResource {
        ...JumpToTrainingResource
      }
      orgPremiumContentConfig {
        ...JumpToOrgPremiumContentConfig
      }
      orgSharpConfig {
        id
      }
      searchHeadline
    }
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}
${JumpToTrainingResourceFragmentDoc}
${JumpToOrgPremiumContentConfigFragmentDoc}`;

/**
 * __useJumpToLibraryItemsQuery__
 *
 * To run a query within a React component, call `useJumpToLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useJumpToLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<JumpToLibraryItemsQuery, JumpToLibraryItemsQueryVariables> & ({ variables: JumpToLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToLibraryItemsQuery, JumpToLibraryItemsQueryVariables>(JumpToLibraryItemsDocument, options);
      }
export function useJumpToLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToLibraryItemsQuery, JumpToLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToLibraryItemsQuery, JumpToLibraryItemsQueryVariables>(JumpToLibraryItemsDocument, options);
        }
export type JumpToLibraryItemsQueryHookResult = ReturnType<typeof useJumpToLibraryItemsQuery>;
export type JumpToLibraryItemsLazyQueryHookResult = ReturnType<typeof useJumpToLibraryItemsLazyQuery>;
export type JumpToLibraryItemsQueryResult = Apollo.QueryResult<JumpToLibraryItemsQuery, JumpToLibraryItemsQueryVariables>;
export const JumpToLocationGroupsDocument = gql`
    query JumpToLocationGroups {
  LocationGroups {
    objects {
      ...JumpToLocationGroup
    }
  }
}
    ${JumpToLocationGroupFragmentDoc}`;

/**
 * __useJumpToLocationGroupsQuery__
 *
 * To run a query within a React component, call `useJumpToLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToLocationGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJumpToLocationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<JumpToLocationGroupsQuery, JumpToLocationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToLocationGroupsQuery, JumpToLocationGroupsQueryVariables>(JumpToLocationGroupsDocument, options);
      }
export function useJumpToLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToLocationGroupsQuery, JumpToLocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToLocationGroupsQuery, JumpToLocationGroupsQueryVariables>(JumpToLocationGroupsDocument, options);
        }
export type JumpToLocationGroupsQueryHookResult = ReturnType<typeof useJumpToLocationGroupsQuery>;
export type JumpToLocationGroupsLazyQueryHookResult = ReturnType<typeof useJumpToLocationGroupsLazyQuery>;
export type JumpToLocationGroupsQueryResult = Apollo.QueryResult<JumpToLocationGroupsQuery, JumpToLocationGroupsQueryVariables>;
export const JumpToLocationsDocument = gql`
    query JumpToLocations {
  Locations {
    objects {
      ...JumpToLocation
    }
  }
}
    ${JumpToLocationFragmentDoc}`;

/**
 * __useJumpToLocationsQuery__
 *
 * To run a query within a React component, call `useJumpToLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJumpToLocationsQuery(baseOptions?: Apollo.QueryHookOptions<JumpToLocationsQuery, JumpToLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToLocationsQuery, JumpToLocationsQueryVariables>(JumpToLocationsDocument, options);
      }
export function useJumpToLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToLocationsQuery, JumpToLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToLocationsQuery, JumpToLocationsQueryVariables>(JumpToLocationsDocument, options);
        }
export type JumpToLocationsQueryHookResult = ReturnType<typeof useJumpToLocationsQuery>;
export type JumpToLocationsLazyQueryHookResult = ReturnType<typeof useJumpToLocationsLazyQuery>;
export type JumpToLocationsQueryResult = Apollo.QueryResult<JumpToLocationsQuery, JumpToLocationsQueryVariables>;
export const JumpToRoleGroupsDocument = gql`
    query JumpToRoleGroups {
  RoleGroups {
    objects {
      ...JumpToRoleGroup
    }
  }
}
    ${JumpToRoleGroupFragmentDoc}`;

/**
 * __useJumpToRoleGroupsQuery__
 *
 * To run a query within a React component, call `useJumpToRoleGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToRoleGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToRoleGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJumpToRoleGroupsQuery(baseOptions?: Apollo.QueryHookOptions<JumpToRoleGroupsQuery, JumpToRoleGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToRoleGroupsQuery, JumpToRoleGroupsQueryVariables>(JumpToRoleGroupsDocument, options);
      }
export function useJumpToRoleGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToRoleGroupsQuery, JumpToRoleGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToRoleGroupsQuery, JumpToRoleGroupsQueryVariables>(JumpToRoleGroupsDocument, options);
        }
export type JumpToRoleGroupsQueryHookResult = ReturnType<typeof useJumpToRoleGroupsQuery>;
export type JumpToRoleGroupsLazyQueryHookResult = ReturnType<typeof useJumpToRoleGroupsLazyQuery>;
export type JumpToRoleGroupsQueryResult = Apollo.QueryResult<JumpToRoleGroupsQuery, JumpToRoleGroupsQueryVariables>;
export const JumpToRolesDocument = gql`
    query JumpToRoles {
  Roles {
    objects {
      ...JumpToRole
    }
  }
}
    ${JumpToRoleFragmentDoc}`;

/**
 * __useJumpToRolesQuery__
 *
 * To run a query within a React component, call `useJumpToRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJumpToRolesQuery(baseOptions?: Apollo.QueryHookOptions<JumpToRolesQuery, JumpToRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToRolesQuery, JumpToRolesQueryVariables>(JumpToRolesDocument, options);
      }
export function useJumpToRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToRolesQuery, JumpToRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToRolesQuery, JumpToRolesQueryVariables>(JumpToRolesDocument, options);
        }
export type JumpToRolesQueryHookResult = ReturnType<typeof useJumpToRolesQuery>;
export type JumpToRolesLazyQueryHookResult = ReturnType<typeof useJumpToRolesLazyQuery>;
export type JumpToRolesQueryResult = Apollo.QueryResult<JumpToRolesQuery, JumpToRolesQueryVariables>;
export const JumpToTagsDocument = gql`
    query JumpToTags {
  Tags: AdminTags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useJumpToTagsQuery__
 *
 * To run a query within a React component, call `useJumpToTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJumpToTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJumpToTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJumpToTagsQuery(baseOptions?: Apollo.QueryHookOptions<JumpToTagsQuery, JumpToTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JumpToTagsQuery, JumpToTagsQueryVariables>(JumpToTagsDocument, options);
      }
export function useJumpToTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JumpToTagsQuery, JumpToTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JumpToTagsQuery, JumpToTagsQueryVariables>(JumpToTagsDocument, options);
        }
export type JumpToTagsQueryHookResult = ReturnType<typeof useJumpToTagsQuery>;
export type JumpToTagsLazyQueryHookResult = ReturnType<typeof useJumpToTagsLazyQuery>;
export type JumpToTagsQueryResult = Apollo.QueryResult<JumpToTagsQuery, JumpToTagsQueryVariables>;